import { ChevronIcon } from 'components/icons'
import { Combobox, ComboboxOption, CustomItemComponent } from 'components/ui'
import classNames from 'helpers/class-names'
import { isEqual } from 'lodash'
import { Dispatch, FC, useCallback } from 'react'

interface Props {
  selected: ComboboxOption
  setSelected: Dispatch<ComboboxOption>
  disabled?: boolean
}

const MaterialCombobox: FC<Props> = ({
  selected,
  setSelected,
  disabled = false,
}) => {
  const materials: Array<ComboboxOption> = [
    {
      id: 'aluminum',
      value: 'Aluminum',
    },
    {
      id: 'mild-steel',
      value: 'Mild Steel',
    },
    {
      id: 'stainless',
      value: 'Stainless',
    },
  ]

  const ComboboxButton = ({
    id,
    options,
  }: {
    id: string
    options: Array<ComboboxOption>
  }) => {
    return (
      <div
        className={classNames('flex flex-row items-center gap-0.5', {
          'cursor-not-allowed': disabled,
        })}>
        {options.find((material) => material.id === id).value}
        {!disabled && (
          <ChevronIcon className="size-8 rotate-90 text-gray-400" />
        )}
      </div>
    )
  }

  const OptionComponent: CustomItemComponent = useCallback(
    ({ id }) => {
      const option = materials.find(
        (option: ComboboxOption) => option.id === id,
      ) as ComboboxOption
      const isSelected = isEqual(selected, option)

      return (
        <div className="flex items-center">
          <div
            className={classNames(
              'truncate text-3xl tracking-normal text-gray-300',
              {
                'text-gray-400': isSelected,
              },
            )}>
            {option?.value}
          </div>
        </div>
      )
    },
    [selected],
  )

  return (
    <Combobox
      variant="display"
      name="material"
      setSelected={setSelected}
      selected={selected}
      id="onboarding-material"
      className="min-w-64 rounded border-none"
      options={materials}
      optionsWrapperClassName="rounded-lg mt-2"
      UnfoldComponent={() => <></>} // Hide unfold component entirely and place chevron next to name.
      ButtonComponent={ComboboxButton}
      OptionComponent={OptionComponent}
      activeClassName={'bg-gray-50'}
      disabled={disabled}
    />
  )
}

export default MaterialCombobox
